"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultTrackingService = exports.GtmTrackingHandler = exports.ConsoleTrackingHandler = void 0;
class ConsoleTrackingHandler {
    track(trackingObject) {
        if (console) {
            if (trackingObject) {
                console.log(trackingObject);
            }
            else {
                console.log('Empty tracking object.');
            }
        }
    }
}
exports.ConsoleTrackingHandler = ConsoleTrackingHandler;
class GtmTrackingHandler {
    static get dataLayerKey() { return 'dataLayer'; }
    constructor() {
        if (!window[GtmTrackingHandler.dataLayerKey]) {
            window[GtmTrackingHandler.dataLayerKey] = [];
        }
    }
    track(trackingObject) {
        if (window[GtmTrackingHandler.dataLayerKey] && trackingObject) {
            window[GtmTrackingHandler.dataLayerKey].push(trackingObject);
        }
    }
}
exports.GtmTrackingHandler = GtmTrackingHandler;
class DefaultTrackingService {
    track(trackingObject, trackingHandlers) {
        try {
            if (trackingHandlers) {
                for (let i = 0; i < trackingHandlers.length; i++) {
                    trackingHandlers[i].track(trackingObject);
                }
            }
        }
        catch (_a) {
            // continue regardless of error
        }
    }
}
exports.DefaultTrackingService = DefaultTrackingService;
